require('roc-slot/spingames');
require('roc-slot/common/feature-freespin');
require('./addPays.js');
require('./fancy_belly.js');
require('./game.css');
require('./fancy_belly.css');
require('./hider.css');

$.ready(function() {
	game.dimensions.width  = 1740;
	game.dimensions.height = 1097;
	
	game.panel.buildHelp(7);
	
	/* globals controller spinDone */
	game.sounds.loadSounds({
		// _base: base,
		konami_bell: require('./sounds/FeatureTrigger.mp3'),
		bell: require('./sounds/FeatureTrigger.mp3'),
		trigger: require('./sounds/bell.mp3'),
		drop: {
			// '0': [ null, null, null, null, null ],
			'12': [
				require('./sounds/drop/12/ScatterOrchHit01.mp3'),
				require('./sounds/drop/12/ScatterOrchHit02.mp3'),
				require('./sounds/drop/12/ScatterOrchHit03.mp3'),
				require('./sounds/drop/12/ScatterOrchHit04.mp3'),
				require('./sounds/drop/12/ScatterOrchHit05.mp3'),
			],
		},
		reel: [
			require('./sounds/reel/reel.mp3'),
			require('./sounds/reel/reel.mp3'),
			require('./sounds/reel/reel.mp3'),
			require('./sounds/reel/reel.mp3'),
			require('./sounds/reel/reel.mp3'),
		],
		reel_start: require('./sounds/reel_start.mp3'),
		anticipate: {
			12: require('./sounds/anticipate/LongerSpin.mp3'),
		},
		multi_sweep: require('./sounds/MultiSweep.mp3'),
		multi_sweep_twinkle: require('./sounds/MultiSweepBell.mp3'),
		buttons: {
			denoms: {
				denom_0: require('./sounds/buttons/denoms/denom-12.mp3'),
				denom_1: require('./sounds/buttons/denoms/denom-11.mp3'),
				denom_2: require('./sounds/buttons/denoms/denom-10.mp3'),
				denom_3: require('./sounds/buttons/denoms/denom-9.mp3'),
				denom_4: require('./sounds/buttons/denoms/denom-8.mp3'),
				denom_5: require('./sounds/buttons/denoms/denom-7.mp3'),
				denom_6: require('./sounds/buttons/denoms/denom-6.mp3'),
			},
			coins: {
				bet_0: require('./sounds/buttons/coins/Bet_1.mp3'),
				bet_1: require('./sounds/buttons/coins/Bet_2.mp3'),
				bet_2: require('./sounds/buttons/coins/Bet_3.mp3'),
				bet_3: require('./sounds/buttons/coins/Bet_4.mp3'),
				bet_4: require('./sounds/buttons/coins/Bet_5.mp3'),
				bet_5: require('./sounds/buttons/coins/Bet_6.mp3'),
				bet_6: require('./sounds/buttons/coins/Bet_6.mp3'),
				bet_7: require('./sounds/buttons/coins/Bet_6.mp3'),
				bet_8: require('./sounds/buttons/coins/Bet_6.mp3'),
			},
			max: require('./sounds/buttons/max_bet.mp3'),
			sound: require('./sounds/buttons/volume.mp3'),
			help: require('./sounds/buttons/open.mp3'),
			close: require('./sounds/buttons/close.mp3'),
			next: require('./sounds/buttons/next.mp3'),
			prev: require('./sounds/buttons/prev.mp3'),
		},
		freespin: {
			// default intro sound has bad timing for this title, used in freespin init
			intro: require('./sounds/freespin/BgmIntro.mp3'),
			background2: require('./sounds/freespin/BgmFg.mp3'),
			smallTrigger: require('./sounds/freespin/FeatureTriggerShort.mp3'),
			countUp: require('./sounds/freespin/FreeGameCountUp.mp3'),
			
		},
		pick: {
			waiting: require('./sounds/pick/WaitingVer2.mp3'),
			pick: require('./sounds/pick/FgSelect_Ver1.mp3'),
			mysteryPick: require('./sounds/pick/FgSelectMystery_Stem_Hit.mp3'),
			mysteryRollup: require('./sounds/pick/FgSelectMystery_Stem_Snareroll.mp3'),
			mysteryFinish: require('./sounds/pick/FgSelectMystery_Stem_Tutti.mp3'),
		},
		multiplierReveal: require('./sounds/Multiple_Stem.mp3'),
		multiplierTypes: [ require('./sounds/Multiple_Stem_X.mp3'), require('./sounds/Multiple_Stem_XX.mp3'), require('./sounds/Multiple_Stem_XXX.mp3') ],
		quake: require('./sounds/rumble.mp3'),
		win: {
			// decor : 'decor',
			intro1: require('./sounds/win/intro1.mp3'),
			intro2: require('./sounds/win/intro2.mp3'),
			win_1: require('./sounds/win/Level1_WinKP35V1_02.mp3'),
			win_2: require('./sounds/win/Level2_WinKP35V1_11.mp3'),
			win_3: require('./sounds/win/Level3_WinKP35V1_14.mp3'),
			bigwin_1: require('./sounds/win/Level4_WinKP35V1_17.mp3'),
			bigwin_2: require('./sounds/win/Level5_WinKP35V1_23.mp3'),
			bigwin_3: require('./sounds/win/Level6_WinKP35V1_30.mp3'),
		},
		konami_base_fallback: require('./sounds/konami_base_fallback.mp3'),
	});
	
	game.specials = {
		12: { reels: [ 0, 1, 2, 3, 4 ], min: 2, needs: 3, anticipate: true },
	};
	
	game.pays.forceCycles = true;
	let numCoins = 31;
	let coinTimeout = 0;
	let celebrateTimeout = 0;
	let startCelebrateTimeout = 0;
	
	let reels = $.div('reels');
	reels.prependTo(game.container);
		
	let actionLogo = $.div('action-logo');
	actionLogo.appendTo(game.container);
	
	let xtraReward = $.div('xtra-reward');
	xtraReward.appendTo(game.container);
	
	let fortune = {};
		
	let freespin = game.features.freespin = game.generateFreespin({ symbol: 12, introTime: 1, banners: 1, noAutomatedSounds: true, outroTime: 500 });
	
	freespin.dimensions = {
		width:	1920,
		height: 1222,
		font: 32,
	};

	let choose = game.features.choose_math = $.div('bonus-choose');
	choose.pick = $.div('choose').addClass('hide').appendTo(choose);
	choose.key = 'choose_math';
	
	choose.intro = $.div().addClass('intro').appendTo(choose);
	choose.intro.text = $.div().addClass('text').appendTo(choose.intro);
	choose.intro.number = $.div().addClass('number').appendTo(choose.intro);
	
	let items = $.div().addClass('items').appendTo(choose.pick);
	choose.items = [];
	for (let i = 0; i < 5; i++) {
		choose.items[i] = $.div().addClass('item item-' + i).appendTo(items);
		choose.items[i].flourish = $.div().addClass('flourish').appendTo(choose.items[i]);
	}
	
	choose.items[2].spins = $.div().addClass('spins').appendTo(choose.items[2]);
	
	choose.items[2].multipliers = [];
	choose.items[2].multipliers[0] = $.div().addClass('mult mult-1').appendTo(choose.items[2]);
	choose.items[2].multipliers[1] = $.div().addClass('mult mult-2').appendTo(choose.items[2]);
	choose.items[2].multipliers[2] = $.div().addClass('mult mult-3').appendTo(choose.items[2]);
	
	// set to false at the beginning of each spin, conditionally set to true when pays are shown
	let line_indicators = game.frame.line_indicators = [];
	
	game.features.choose_math.methods = {
		choose: function(response) {
			let delay = 2000;
			
			game.addClass('_' + response.index);
			game.sounds.stop([ 'pick', 'waiting' ]);
			
			if (response.index !== 2) {
				game.sounds.play([ 'pick', 'pick' ]);
			}
			
			for (let item in choose.items) {
				if (choose.items[item].hasClass('picked')) {
					choose.items[item].flourish.addClass('picked');
				}
				
				else {
					choose.items[item].flourish.addClass('none');
				}
			}
			
			if (typeof game.last.spins !== 'undefined') {
				game.last.spins = response.spins;
				freespin.spins.set(game.last.spins);
				choose.intro.addClass('x' + response.spins);
				choose.pickedMults = response.chosen_mults;
			}
			
			if ( response.index === 2) {
				let possibleMults = [];
				let possibleSpins = [];
				let timer = 50;
				
				delay = 7000;
				
				possibleSpins = [ 3, 5, 10, 20 ];
				
				possibleMults[0] = [ 2, 3, 5 ];
				possibleMults[1] = [ 5, 8, 10 ];
				possibleMults[2] = [ 10, 15, 30 ];
				possibleMults[3] = [ 15, 30, 40 ];
				
				game.sounds.play([ 'pick', 'mysteryRollup' ]);
				
				for (let index = 0; index < 40; index++) {
					setTimeout(function() {
						choose.items[response.index].spins.attr('class', 'spins show x' + possibleSpins[index % 4]);
					}, timer);
					
					timer += 50;
				}
				
				choose.items[response.index].multipliers[0].attr('class', 'mult mult-1 spin show');
				choose.items[response.index].multipliers[1].attr('class', 'mult mult-2 spin show');
				choose.items[response.index].multipliers[2].attr('class', 'mult mult-3 spin show');
				
				setTimeout(function() {
					game.sounds.play([ 'pick', 'mysteryPick' ]);
					game.sounds.play([ 'pick', 'mysteryRollup' ]);
					choose.items[response.index].spins.attr('class', 'spins show x' + response.spins);
				}, 2000);

				game.addClass('x' + choose.pickedMults[0]);
				
				setTimeout(function() {
					game.sounds.play([ 'pick', 'mysteryFinish' ]);
					choose.items[response.index].multipliers[0].attr('class', 'mult mult-1 show x' + choose.pickedMults[0]);
					choose.items[response.index].multipliers[1].attr('class', 'mult mult-2 show x' + choose.pickedMults[1]);
					choose.items[response.index].multipliers[2].attr('class', 'mult mult-3 show x' + choose.pickedMults[2]);
				}, 4000);
			}
			
			setTimeout(function() {
				game.sounds.play([ 'freespin', 'intro' ]);
				choose.pick.addClass('hide');
				
				setTimeout(function() {
					game.features.freespin.inited = true;
					game.features.freespin.playing.appendTo(game.panel.play);
					game.panel.show(true);
				}, 2000);
				
				setTimeout(function() {
					game.panel.disable('freespin');

					game.features.freespin.methods.next(response.spins);
				}, 3000);
			}, delay);
		},
	};
	
	let bubbles = 0;
	let recallFinish = false;
	
	game.panel.dialog.pager.bubbles.on('click', function() {
		if (bubbles > game.panel.dialog._page) {
			game.sounds.play([ 'buttons', 'prev' ]);
			bubbles = game.panel.dialog._page;
		}
		else if (bubbles < game.panel.dialog._page) {
			game.sounds.play([ 'buttons', 'next' ]);
			bubbles = game.panel.dialog._page;
		}
	});
	
	// Help screen close
	game.panel.dialog.pager.exit.on('click', function() {
		game.sounds.play([ 'buttons', 'close' ]);
		bubbles = 0;
	});
	
	// Help screen right arrow click
	game.panel.dialog.pager.right.on('click', function() {
		game.sounds.play([ 'buttons', 'next' ]);
		bubbles = game.panel.dialog._page;
	});
	
	// Help screen left arrow click
	game.panel.dialog.pager.left.on('click', function() {
		game.sounds.play([ 'buttons', 'prev' ]);
		bubbles = game.panel.dialog._page;
	});
	
	game.on('ui', function(e) {
		fortune.coins = $.div().addClass('fortune coins').appendTo(game.pays);
		fortune.coins.coins  = [];
		fortune.coins.coin = 0;
		
		// Adding xtra reward cost to panel
		game.feature.cost = e.detail.xtra_reward.cost;
		game.pays.cost = 0.5;
		
		game.panel.disableBigWins([ 1, 3, 4, 6, 10, 14 ]);
		
		// Div's used for when 2 of a Kind shows full Line instead of Split lines
		let middleReelBlocks = game.frame.reels[2].middleReelBlocks = [];
		middleReelBlocks[0] = $.div().addClass('Row-0').appendTo(game.frame.reels[2]);
		middleReelBlocks[1] = $.div().addClass('Row-1').appendTo(game.frame.reels[2]);
		middleReelBlocks[2] = $.div().addClass('Row-2').appendTo(game.frame.reels[2]);
		
		for (var i = 0; i < numCoins; i++) {
			fortune.coins.coins[i] = $.div().addClass('coin-' + i).appendTo(fortune.coins);
		}

		fortune.stacks = $.div().addClass('fortune stacks').appendTo(game.pays);
		
		line_indicators[0] = $.div().addClass('line_indicator left').prependTo(game.pays);
		line_indicators[1] = $.div().addClass('line_indicator right').prependTo(game.pays);

		if (e.detail.recall && e.detail.recall.actions) {
			for (var recallAction in e.detail.recall.actions) {
				var type = e.detail.recall.actions[recallAction].response;

				if (type.action === 'finish') {
					recallFinish = true;
				}
			}
		}
	});
	
	game.on('bet', function(e) {
		e.detail.feature_cost = game.feature.cost;
	});
	
	game.panel.lines.on('update', function(e) {
		let value = this.values[this.value] / 2;
		
		value = $.plugins.meter.__format(value);
		
		if (game.panel.type === 'mobile') {
			game.panel.lines.items[0].label.html(value);
		}
		
		else {
			this.field.html(value);
		}
	});
	
	game.on('ready', function() {
		// Default bell timing is not right for this title, plays on freespin init
		setTimeout(function() {
			if (!game.sounds.fallback) {
				game.sounds.sounds.bell = null;
			}
		}, 15);
	});

	game.on('spin_init', function(e) {
		// REPLACE FEATURE
		this.spindle.attr('class', 's' + this.last.replace);
		this.frame.reels[2].attr('class', 'reel reel-2');
		
		if (!game.feature.active) {
			game.messaging.show('logo');
		}
	});
	
	game.pays.on('pay', function(e) {
		let pay = e.detail;
		let match = -1;
		
		if (pay.type === 'scatter') {
			return;
		}
		
		if (pay.line > 29) {
			pay.line %= 30;
			pay.lineAugment = ' B';
		}
		
		else {
			pay.lineAugment = ' A';
		}
		
		for (let line in game.pays.list) {
			if (game.pays.list[line].line === pay.line ) {
				match = line;
				break;
			}
		}
		
		if (match === -1 && pay.spots.length === 2) {
			pay.lineAugment = '';
		}
		
		else if (match !== -1 && pay.spots.length !== 2) {
			if (game.pays.list[match].spots.length === 2) {
				if (pay.lineAugment === ' A') {
					game.pays.list[match].lineAugment = ' B';
				}
				
				else {
					game.pays.list[match].lineAugment = ' A';
				}
			}
		}
	});
	
	game.pays.on('line', function(e) {
		let line = e.detail;
		let row = 0;
		
		if (line.reel !== 2 || !line.pay) {
			return;
		}
		
		if (line.pay.lineAugment === ' B') {
			line.line = game.pays.lines[line.lineNumber + 30];
			row = line.line[2];
			line.track = game.frame.reels[line.reel].symbols[row];
		}
		
		else if ( line.pay.lineAugment === '') {
			row = Math.floor(line.line[2] / 2);
			line.track = game.frame.reels[line.reel].middleReelBlocks[row];
		}
	});
	
	game.on('spin_pre_done', function() {
		let index = 0;

		if (!game.feature.active && !game.last.introShown && game.last.scatters.counts[12] > 2 && !recallFinish) {
			// game.last.delayWin = true;
			game.last.introShown = true;
			game.last.delayBonus = true;
			showBonusIntro(3000);
		}
		
		else if (game.last.wild_multiplier && !game.last.multShown) {
			game.frame.addClass('win');
			
			game.frame.reels[2].addClass('x');
			game.frame.reels[2].addClass('x' + game.last.wild_multiplier);
			game.frame.reels[2].addClass('intro');
			
			for (index = 0; index < choose.pickedMults.length; index++) {
				if (game.last.wild_multiplier === choose.pickedMults[index]) {
					break;
				}
			}
			
			game.sounds.play('multiplierReveal');
			
			setTimeout(function() {
				game.sounds.play([ 'multiplierTypes', index ]);
			}, 500);
			
			setTimeout(function() {
				game.frame.reels[2].removeClass('intro');
			}, 2000);
			
			game.last.delayWin = true;
			game.last.multShown = true;
			
			setTimeout(function() {
				game.last.delayWin = false;
				spinDone();
				game.frame.addClass('win');
			}, 2000);
		}
		
		else if (!game.last.delayed) {
			decideCoins();
		}
	});
	
	game.on('spin_done', function() {
		if (game.feature.active && game.last.scatters.win && game.last.name) {
			choose.intro.addClass('show');
			choose.intro.addClass('retrigger');
			game.sounds.play([ 'freespin', 'smallTrigger' ]);
			
			setTimeout(function() {
				choose.intro.removeClass('show');
			}, 2000);
		}
	});
	
	game.on('reel_stop', function(e) {
		var index = e.detail.index;
		
		fitToFrame(index);
	});
	
	freespin.on('init', function(e) {
		// let recall = e.detail.reacall;
		choose.clicked = true;
		
		if (game.old) {
			game.old.quickTransition = false;
		}
		
		game.panel.disable(true);
		
		choose.items[2].spins.attr('class', 'spins');
		choose.items[2].multipliers[0].attr('class', 'mult mult-1');
		choose.items[2].multipliers[1].attr('class', 'mult mult-2');
		choose.items[2].multipliers[2].attr('class', 'mult mult-3');
		
		setTimeout(function() {
			game.panel.hide(true);
		}, 100);
		
		game.sounds.sounds.freespin.background = null;
	});
	
	freespin.on('begin', function(e) {
		choose.appendTo(game.feature);
		game.last.delayWin = true;
		game.features.freespin.play.remove();
		game.features.freespin.play.message.html('');
		
		setTimeout(function() {
			if (game.last.spins_aquired === 0) {
				choose.pick.removeClass('hide');
				choose.clicked = false;
				
				setTimeout(function() {
					game.endCelebrate();
				}, 1000);
			}
			else {
				game.addClass('_' + game.config.recover.chosen_index);
				game.addClass('x' + game.config.recover.chosen_mults[0]);
				
				choose.pickedMults = game.config.recover.chosen_mults;
				choose.intro.addClass('x' + game.config.recover.chosen_spins);
				
				game.panel.show(true);
				choose.intro.removeClass('show');
				choose.clicked = true;
				
				game.features.freespin.inited = true;
				
				setTimeout(function() {
					game.features.freespin.methods.next(game.last.spins);
				}, 1000);
			}
			
			game.sounds.play([ 'pick', 'waiting' ], true);
		}, 3000);
	});
	
	freespin.on('spin', function() {
		if (game.panel.play.hasClass('icon-begin')) {
			game.panel.play.removeClass('icon-begin');
			game.panel.play.addClass('icon-spin');
		}
		
		if (!this.swappedTheBackground) {
			this.swappedTheBackground = true;
			game.sounds.sounds.freespin.background = game.sounds.sounds.freespin.background2;
			game.sounds.play([ 'freespin', 'background' ], true);
		}
	});
	
	freespin.on('finish', function() {
		game.attr('class', '');
		this.swappedTheBackground = false;
		game.old.delayed = false;
		
		setTimeout(function() {
			game.messaging.show('logo');
			
			setTimeout(function() {
				game.panel.setWin(game.last.win);
			}, 1000);
			
			if (game.autoplay.isActive()) {
				setTimeout(function() {
					game.play();
				}, 2000);
			}
			
			for (let item in choose.items) {
				choose.items[item].removeClass('picked');
				choose.items[item].flourish.removeClass('none');
			}
			
			game.panel.setCredits(game.last.credits);
		}, 1500);
	});
	
	choose.on('click', 'item', function() {
		if (choose.clicked) {
			return;
		}
		
		this.addClass('picked');
		
		choose.clicked = true;
		controller.socket.emit('feature', { name: 'choose_math', action: 'choose', index: this.index() });
	});

	game.startCelebrate = function() {
		fortune.stacks.addClass('shimmer');
		
		celebrateTimeout = setTimeout(function() {
			celebrateTimeout = setTimeout(function() {
				fortune.coins.addClass('flip');
				coinTimeout = setInterval(function() {
					game.flipCoins();
				}, (2000 / (numCoins - 2)));
			}, 0);
		}, 450);
	};
	
	game.flipCoins = function() {
		var current = fortune.coins.coin;
		var coin = Math.floor(Math.random() * (6 - 1 + 1)) + 1; // coin image
		var left = Math.floor(Math.random() * (85 - 15 + 1)) + 15; // css displacement
		
		fortune.coins.coins[current].css('left', 50 + '%');
		fortune.coins.coins[current].attr('class', 'flip coin-' + coin);
		
		setTimeout(function() {
			fortune.coins.coins[current].css('left', left + '%');
		}, 250);
		
		setTimeout(function() {
			fortune.coins.coins[current].removeClass('flip');
		}, 2000);
		
		fortune.coins.coin = ((fortune.coins.coin + 1) % fortune.coins.coins.length);
	};
	
	game.endCelebrate = function() {
		clearInterval(coinTimeout);
		clearInterval(celebrateTimeout);
		clearInterval(startCelebrateTimeout);
		
		fortune.coins.removeClass('flip');
		fortune.stacks.removeClass('shimmer');
		
		game.removeClass('quake');
		game.removeClass('quakeVert');
	};
	
	game.on('round_complete', function() {
		game.endCelebrate();
		
		if (game.last.bonuses && game.last.bonuses.length && !recallFinish) {
			game.feature.begin(game.last.bonuses.pop());
			game.last.triggereBonus = true;
		}
	});
	
	game.panel.spin.on('click', function() {
		game.endCelebrate();
		
		game.removeClass('quakeVert');
		game.removeClass('quake');
	});
	
	game.panel.disableBigWins = function(durations) {
		this.bigwin.celebrations = {};
		
		for (var i = 0; i < this.bigwin.levels.length; i++) {
			this.bigwin.levels[i] = [ this.bigwin.levels[i][this.bigwin.levels[i].length - 1] ];
			
			if ( this.bigwin.levels[i][0].duration ) {
				this.bigwin.levels[i][0].duration = undefined;
				delete this.bigwin.levels[i][0].duration;
			}
			
			if (durations && durations[i]) {
				this.bigwin.levels[i][0].duration = durations[i];
			}
			
			if ( this.bigwin.levels[i][0].celebration ) {
				this.bigwin.levels[i][0].celebration = undefined;
				delete this.bigwin.levels[i][0].celebration;
			}
		}
	};
	
	function fitToFrame(index) {
		for (var col = 0; col < game.config.reels; col++) {
			let rowLength = game.config.rows[col];
			
			for (var row = 0; row < rowLength; row++) {
				if (game.last.matrix[typeof index === 'number' ? index : col][row] === 12 && !game.last.animate[col][row]) {
					game.frame.reels[typeof index === 'number' ? index : col].symbols[row].addClass('symbol symbol-12');
				}
			}
		}
	}
	
	function decideCoins() {
		var decide = 0;
		var factor = 5;
		var winFactor = 0;
		var win = game.last.win;
		
		if (game.last._cost) {
			winFactor = win / (game.last._cost);
		}
		else if (game.old && game.old._cost) {
			winFactor = win / (game.old._cost);
		}
		else if (game.old && game.old._cost === 0) {
			winFactor = win / ((game.panel.lines.get()) * game.panel.coins.get());
		}
		
		for (decide = 0; decide < game.panel.bigwin.breakpoints.length; decide++) {
			if (winFactor < game.panel.bigwin.breakpoints[decide]) {
				break;
			}
		}

		if (decide >= factor) {
			game.last.delayWin = true;
			game.frame.addClass('win');
			game.addClass('quake');
			game.addClass('quakeVert');
			game.sounds.play('quake');
			
			startCelebrateTimeout = setTimeout(function() {
				game.startCelebrate();
				game.last.delayWin = false;
				game.last.delayed = true;
				
				if (game.last.bonuses && game.last.bonuses.length || game.last.triggereBonus) {
					game.last.delayBonus = true;
				}

				spinDone();
				game.frame.addClass('win');
				game.removeClass('quake');
				game.removeClass('quakeVert');
				
				if (game.last.bonuses && game.last.bonuses.length) {
					game.pays.show();
				}
			}, 2000);
		}
	}
	
	function showBonusIntro(time) {
		let message = $.div().addClass('false-messages').appendTo(game.pays);
		let text = $.div().addClass('text');
		
		message.addClass('intro');
		text.appendTo(message);
		game.sounds.play('konami_bell');
		
		setTimeout(function() {
			message.attr('class', 'false-messages');
			message.remove();
			
			game.messaging.hide('logo');
			game.panel.setWin(game.last.win);
			game.last.delayBonus = true;

			spinDone();
			
			if (game.last.scatters.counts[12] < 5) {
				game.pays.show();
			}
		}, time);
	}
	
	// recover cost
	game.on('ui', function(e) {
		if (!game.last._cost) {
			setTimeout(function() {
				var bet = game.panel.getBet();
				game.last._cost = bet.coins * bet.lines;
			}, 1);
		}
	});
	// --new
});



/** WEBPACK FOOTER **
 ** ./public-src/game.js
 **/